<template>
  <div class="print-container">
    <!-- 打印设置栏 -->
    <div 
      class="print-setting" 
      style="background:#5d9cec;text-align:center;position:fixed;left:0;top:0;width:100%;padding:5px;z-index:9999"
    >
      <div class="setting-item">
        <div class="setting-txt">打印机选择</div>
        <select 
          class="printers border-l border-r" 
          style="width:150px;vertical-align:top"
          v-model="selectedPrinter"
        >
          <option 
            v-for="(printer, index) in printerList" 
            :key="index" 
            :value="index"
          >
            {{ printer }}
          </option>
        </select>
        <select 
          class="print-direction" 
          style="width:auto"
          v-model="printDirection"
        >
          <option value="1">纵向</option>
          <option value="2">横向</option>
        </select>
      </div>

      <div class="setting-item hidden-xs" style="margin-left:10px">
        <div class="setting-txt">上下边距（mm）：</div>
        <input 
          class="distance-top border-l" 
          style="width:40px;padding:0 5px"
          v-model.number="distanceTop" 
          type="number"
        >
      </div>

      <div class="setting-item hidden-xs" style="margin-left:10px">
        <div class="setting-txt">左右边距（mm）：</div>
        <input 
          class="distance-left border-l" 
          style="width:40px;padding:0 5px"
          v-model.number="distanceLeft" 
          type="number"
        >
      </div>

      <div class="setting-item hidden-xs" style="margin-left:10px">
        <div class="setting-txt">纸张类型：</div>
        <select 
          class="paper-type border-l" 
          style="width:150px"
          v-model="selectedPaperType"
          @change="handlePaperTypeChange"
        >
          <option 
            v-for="paper in paperTypeList" 
            :key="paper" 
            :value="paper"
          >
            {{ paper }}
          </option>
        </select>
        <span 
          class="paper-size" 
          :class="{ hidden: selectedPaperType !== '自定义' }"
        >
          宽（mm）：<input 
            class="border-input paper-width" 
            style="margin-right:10px"
            v-model.number="paperWidth" 
            type="number"
          >
          高（mm）：<input 
            class="border-input paper-height"
            v-model.number="paperHeight" 
            type="number"
          >
        </span>
      </div>

      <button 
        class="btn" 
        style="height:25px;line-height:0;color:#fff;background:#000;margin-left:20px"
        @click="lodopPrint"
      >
        打印
      </button>

      <div style="float: right; cursor: pointer;">
        <button 
          class="btn btn-default btn-flat btn-xs pull-right" 
          type="button"
          @click="goBack"
        >
          <i class="fa fa-mail-reply"></i> 返回
        </button>
      </div>
    </div>

    <!-- 出库单列表渲染 -->
    <div 
      v-for="(order, orderIndex) in orderList" 
      :key="orderIndex" 
      class="bill"
    >
      <div style="font-family: Microsoft YaHei,tahoma,arial,\5b8b\4f53, Sans-Serif; font-size:12px;color: #333;padding: 0">
        <h3 style="text-align:center;font-size:30px; margin-top:15px;margin-bottom:15px">华炜管理系统—出库单</h3>
        
        <div class="order-title">
          <table width="100%" cellpadding="0" cellspacing="0" style="font-size:17px">
            <tbody>
              <tr>
                <td style="text-align:left">
                  <div style="float:left;">
                    <dl>
                      <dd style="line-height:19px;">单位：{{ order.factory }}</dd>
                    </dl>
                    <dl>
                      <dd style="line-height:19px;">{{ order.item_number }}/{{ order.order_type }}</dd>
                    </dl>
                  </div>
                  <div style="float:right;">
                    <dl>
                      <dd style="line-height:19px;">下单日期：{{ order.create_times }}</dd>
                    </dl>
                    <dl>
                      <dd style="line-height:19px;">出库日期：{{ order.update_times }}</dd>
                    </dl>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="order-detail">
          <table width="100%" cellpadding="0" cellspacing="0" style="font-size:16px;border:1px solid #000">
            <thead>
              <tr>
                <th style="font-weight:bold;text-align:center;width:30px">序号</th>
                <th style="font-weight:bold;text-align:center;height:30px;width: 500px;">物料名称</th>
                <th style="font-weight:bold;text-align:center;height:30px;width: 500px;">物料编号</th>
                <th style="font-weight:bold;text-align:center;height:30px;width:500px;">计算单位</th>
                <th style="font-weight:bold;text-align:center;height:30px;width:500px;">数量</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(spec, specIndex) in order.specification" 
                :key="specIndex"
              >
                <td style="text-align:center;height:26px;line-height:26px;border:1px solid #000;border-collapse:collapse;">
                  {{ spec.xh }}
                </td>
                <td style="text-align:center;height:26px;line-height:26px;border:1px solid #000;border-collapse:collapse;">
                  {{ spec.name }}
                </td>
                <td style="text-align:center;height:26px;line-height:26px;border:1px solid #000;border-collapse:collapse;">
                  {{ spec.code }}
                </td>
                <td style="text-align:center;height:26px;line-height:26px;border:1px solid #000;border-collapse:collapse;">
                  {{ spec.company }}
                </td>
                <td style="text-align:center;height:26px;line-height:26px;border:1px solid #000;border-collapse:collapse;">
                  {{ spec.num }}
                </td>
              </tr>
              <tr>
                <td style="text-align:center">合计</td>
                <td colspan="5">{{ order.money }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div style="page-break-before:always;"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios' // 替换jQuery的AJAX请求
import {getLodop} from '@/static/print/LodopFuncs.js'
export default {
  name: 'PrintOutboundOrder',
  data() {
    return {
      // URL参数
      aids: '',
      xbs: '',
      // 打印机配置
      printerList: [],        // 打印机列表
      selectedPrinter: 0,     // 选中的打印机索引
      printDirection: 1,      // 打印方向：1-纵向 2-横向
      // 边距配置
      distanceTop: 1.0,       // 上下边距(mm)
      distanceLeft: 10.0,     // 左右边距(mm)
      // 纸张配置
      paperTypeList: [],      // 纸张类型列表
      selectedPaperType: '',  // 选中的纸张类型
      paperWidth: 210.0,      // 自定义纸张宽度(mm)
      paperHeight: 93.2,      // 自定义纸张高度(mm)
      // 业务数据
      orderList: []           // 出库单数据列表
    }
  },
  mounted() {
    // 初始化URL参数
    this.aids = this.getQueryVariable('aids')
    this.xbs = this.getQueryVariable('xbs')
    
    // 初始化核心功能
    this.getOrderData()       // 请求出库单数据
    this.initPrinters()       // 初始化打印机列表
    this.paperInit()          // 初始化纸张类型
  },
  methods: {
    /**
     * 获取URL参数
     * @param {String} variable 参数名
     * @returns {String|Boolean} 参数值/不存在返回false
     */
    getQueryVariable(variable) {
      const query = window.location.search.substring(1)
      const vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=')
        if (pair[0] === variable) return pair[1]
      }
      return false
    },

    /**
     * 请求出库单数据
     */
    async getOrderData() {
      if (!this.aids || !this.xbs) {
        alert('缺少必要的请求参数！')
        return
      }

      try {
        const res = await axios.get(`getshipmentorderdata?aids=${this.aids}&xbs=${this.xbs}`)
        const { status, result, msg } = res.data
        
        if (status === '2000') {
          if (result) {
            this.orderList = result
          } else {
            alert('无相关数据或合作物流商户号非法')
          }
        } else {
          alert(`数据请求失败：${msg}`)
        }
      } catch (error) {
        console.error('出库单数据请求异常：', error)
        alert('网络异常，请刷新页面重试！')
      }
    },

    /**
     * 初始化打印机列表
     */
    initPrinters() {
      const LODOP = getLodop() // 依赖LODOPFuncs.js的全局方法
      LODOP.PRINT_INIT('配货清单')
      
      const printerCount = LODOP.GET_PRINTER_COUNT()
      this.printerList = []
      for (let i = 0; i < printerCount; i++) {
        this.printerList.push(LODOP.GET_PRINTER_NAME(i))
      }
      
      // 监听打印机切换，重新初始化纸张类型
      this.$watch('selectedPrinter', () => {
        this.paperInit()
        this.handlePaperTypeChange()
      })
    },

    /**
     * 初始化纸张类型列表
     */
    paperInit() {
      const LODOP = getLodop()
      const papers = LODOP.GET_PAGESIZES_LIST(this.selectedPrinter, ',')
      
      // 去空并添加自定义选项
      this.paperTypeList = papers.split(',').filter(Boolean)
      this.paperTypeList.push('自定义')
      
      // 默认选中「信纸」
      const letterIndex = this.paperTypeList.findIndex(item => item === '信纸')
      this.selectedPaperType = letterIndex > -1 
        ? this.paperTypeList[letterIndex] 
        : this.paperTypeList[0]
    },

    /**
     * 纸张类型切换处理
     */
    handlePaperTypeChange() {
      // 仅控制自定义纸张尺寸的显示/隐藏（通过模板的class绑定实现）
    },

    /**
     * 返回上一页
     */
    goBack() {
      window.history.back(-1)
    },

    /**
     * LODOP打印核心逻辑
     */
    lodopPrint() {
      const LODOP = getLodop()
      if (!LODOP) {
        alert('打印控件未加载，请检查LODOP安装状态！')
        return
      }

      // 基础配置
      const top = this.distanceTop || 0
      const left = this.distanceLeft || 0
      const printStyle = document.getElementById('print-style')?.innerHTML || ''
      const direction = this.printDirection

      // 设置打印机
      LODOP.SET_PRINTER_INDEXA(this.selectedPrinter)

      // 设置纸张尺寸
      if (this.selectedPaperType === '自定义') {
        const customPaperName = `部落管家 ${this.paperWidth}x${this.paperHeight} mm`
        LODOP.SET_PRINT_PAGESIZE(
          parseInt(direction),
          this.paperWidth * 10,   // LODOP单位是0.1mm，需×10
          this.paperHeight * 10,
          'CreateCustomPage'
        )
        LODOP.SET_PRINT_MODE('CREATE_CUSTOM_PAGE_NAME', customPaperName)
      } else {
        LODOP.SET_PRINT_PAGESIZE(parseInt(direction), 0, 0, this.selectedPaperType)
      }

      // 循环添加打印内容
      const billDomList = document.querySelectorAll('.bill')
      billDomList.forEach(dom => {
        LODOP.ADD_PRINT_HTM(
          `${top}mm`,
          `${left}mm`,
          `RightMargin:${left}mm`,
          `BottomMargin:${top}mm`,
          printStyle + dom.innerHTML
        )
        LODOP.NewPageA() // 每页分页
      })

      // 打印预览配置
      LODOP.SET_PREVIEW_WINDOW(0, 1, 1, 800, 600, '')
      LODOP.SET_SHOW_MODE('HIDE_PAPER_BOARD', 1)
      LODOP.SET_PRINT_MODE('AUTO_CLOSE_PREWINDOW', 1)
      LODOP.PREVIEW() // 预览模式（替换为LODOP.PRINT()可直接打印）
    }
  }
}
</script>

<!-- 组件内样式（scoped需穿透） -->
<style scoped>
/* 基础布局样式 */
body {
  padding-top: 40px;
}
.setting-item {
  display: inline-block;
  font-size: 12px;
  background: #fff;
  border-radius: 5px;
  padding: 0 5px;
  vertical-align: top;
}
.setting-txt {
  margin: 0 5px;
  display: inline-block;
  vertical-align: baseline;
}
.border-l {
  border-left: 1px solid #5d9cec;
}
.border-r {
  border-right: 1px solid #5d9cec;
}
.border-input {
  width: 30px;
  height: 23px;
  line-height: 1.4;
  vertical-align: top;
  margin: 1px 0;
  border: 1px solid #5d9cec;
  border-radius: 5px;
}
input, select {
  display: inline-block;
  height: 25px;
  line-height: 25px;
  padding: 0 3px;
  outline: none;
  border: none;
  font-size: 12px;
  color: #5d9cec;
}
.hidden {
  display: none !important;
}

/* 打印样式穿透（scoped下需要/deep/） */
/deep/ dl {
  padding: 0;
  margin: 0;
}
/deep/ dd {
  margin: 0;
}
/deep/ label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
/deep/ td, /deep/ th {
  display: table-cell;
  vertical-align: inherit;
  padding: 0;
}
/deep/ .order-detail {
  margin-top: 15px;
}
/deep/ .order-detail table {
  border-collapse: collapse;
}
/deep/ .order-detail table td {
  height: 26px;
  line-height: 26px;
  border: solid #000 1px;
}
/deep/ .order-detail table th {
  border: solid #000 1px;
}
/deep/ input[type=number] {
  -moz-appearance: textfield;
}
/deep/ input[type=number]::-webkit-inner-spin-button,
/deep/ input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 打印媒体查询 */
@media print {
  /deep/ .print-setting {
    display: none;
  }
  /deep/ body {
    padding: 0;
    margin: 8px;
  }
}
</style>

<!-- 全局打印样式（建议放到public/index.html中） -->
<style id="print-style">
dl {
  padding: 0;
  margin: 0;
}
dd {
  margin: 0;
}
label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
td, th {
  display: table-cell;
  vertical-align: inherit;
  padding: 0;
}
.order-detail {
  margin-top: 15px;
}
.order-detail table {
  border-collapse: collapse;
}
.order-detail table td {
  height: 26px;
  line-height: 26px;
  border: solid #000 1px;
}
.order-detail table th {
  border: solid #000 1px;
}
.h3 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
body {
  margin: 8px;
}
input[type=number] {
  -moz-appearance: textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>